<template lang="pug">
v-container(fluid)
  v-card
    v-card-title.d-flex.align-center.justify-space-between
      span {{ current?.title || 'Documento' }}
      v-spacer
      v-chip(v-if="current?.status" small :color="statusColor(current.status)" outlined) {{ statusText(current.status) }}
  v-row.mt-2
    v-col(cols="12" md="6")
      v-card
        v-card-title Metadatos
        v-card-text
          v-list(dense)
            v-list-item
              v-list-item-content
                v-list-item-title Categoría
                v-list-item-subtitle {{ findCategoryName(current?.category) || '-' }}
            v-list-item
              v-list-item-content
                v-list-item-title Etiquetas
                v-list-item-subtitle {{ (current?.tags || []).join(', ') || '-' }}
            v-list-item
              v-list-item-content
                v-list-item-title Descripción
                v-list-item-subtitle {{ current?.description || '-' }}
            // Render dinámico de metadata
            template(v-for="(val,key) in (current?.metadata || {})")
              v-list-item(:key="key")
                v-list-item-content
                  v-list-item-title {{ key }}
                  v-list-item-subtitle {{ val }}
    v-col(cols="12" md="6")
      v-card
        v-card-title Versiones
        v-card-text
          v-list(dense)
            v-list-item(v-for="ver in versions" :key="ver._id")
              v-list-item-content
                v-list-item-title {{ ver.filename }}
                v-list-item-subtitle {{ formatDate(ver.createdAt) }} • {{ ver.mime }} • {{ prettySize(ver.size) }}
              v-list-item-action
                v-btn(icon small @click="download(ver)")
                  v-icon mdi-cloud-download
  v-card.mt-3
    v-card-title Permisos (ACL)
    v-card-text
      v-alert(type="info" outlined dense)
        | En Fase 1 el acceso es role-based por defecto. ACL por documento se habilitará en edición avanzada.
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'

export default {
  name: 'VaultDocumentDetail',
  props: { id: { type: String, required: true } },
  computed: {
    ...mapState('vaultDocuments', ['current', 'versions', 'categories'])
  },
  methods: {
    ...mapActions('vaultDocuments', ['fetchDetail', 'getDownloadUrl']),
    formatDate(d) { try { return format(new Date(d), 'dd/MM/yyyy HH:mm', { locale: es }) } catch { return d } },
    prettySize(n) { if (!n && n!==0) return '-'; const mb = n/1024/1024; return mb>=1 ? `${mb.toFixed(2)} MB` : `${(n/1024).toFixed(1)} KB` },
    statusColor(s) { return { vigente: 'success', proximo: 'warning', vencido: 'error', archivado: 'grey' }[s] || 'grey' },
    statusText(s) { return { vigente: 'Vigente', proximo: 'Próximo', vencido: 'Vencido', archivado: 'Archivado' }[s] || s },
    findCategoryName(id) { const c = (this.categories||[]).find(x => x._id === id); return c ? c.name : null },
    async download(ver) { const { url } = await this.getDownloadUrl({ documentId: this.current._id, versionId: ver._id }); window.open(url, '_blank') }
  },
  async created() { await this.fetchDetail(this.$route.params.id) }
}
</script>
